{
  "INBOX_MGMT": {
    "HEADER": "Inboxes",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Ponovno poveži",
      "FACEBOOK": "Povezava s Facebookom je potekla ali je bila preklicana. Sporočila, poslana strani, ne prispejo v ta nabiralnik, odgovori pa morda ne bodo poslani. Oseba, ki upravlja Facebook stran, mora klikniti Ponovno poveži in se prijaviti v Facebook.",
      "INSTAGRAM": "Povezava z Instagramom je potekla ali je bila preklicana. Sporočila, poslana računu, ne prispejo v ta nabiralnik, odgovori pa morda ne bodo poslani. Kliknite Ponovno poveži in se prijavite v isti Instagram račun. Drug račun ustvari nov nabiralnik.",
      "GOOGLE": "Povezava z Googlom je potekla ali je bila preklicana. Nova e-sporočila ne prispejo v ta nabiralnik, odgovori pa morda ne bodo poslani. Kliknite Ponovno poveži in se prijavite v Google kot {email}.",
      "MICROSOFT": "Povezava z Microsoftom je potekla ali je bila preklicana. Nova e-sporočila ne prispejo v ta nabiralnik, odgovori pa morda ne bodo poslani. Kliknite Ponovno poveži in se prijavite v Microsoft kot {email}.",
      "ALLEGRO": "Povezava z Allegrom je potekla ali je bila preklicana. Sporočila kupcev ne prispejo v ta nabiralnik, odgovori pa morda ne bodo poslani. Kliknite Ponovno poveži in se prijavite v Allegro kot prodajalec {seller}. Drug prodajalski račun ustvari nov nabiralnik.",
      "IMAP_LOGIN": "Poštni strežnik zavrača prijavo v IMAP kot {login}. Nova e-sporočila ne prispejo v ta nabiralnik. Preverite prijavno ime in geslo za IMAP na zavihku {tab} ter ju shranite. S prijavo poskušamo še naprej, nabiralnik pa se bo obnovil, takoj ko bo prijava delovala.",
      "WHATSAPP": "Povezava z WhatsAppom je potekla ali je bila preklicana. Priponke strank ne prispejo v ta predal, odgovori pa morda ne bodo uspeli. Kliknite Ponovno poveži, se prijavite v Facebook in znova izberite številko {phone}."
    },
    "LIST": {
      "404": "There are no inboxes attached to this account.",
      "RECONNECT_REQUIRED": "Potrebna je ponovna povezava"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Choose Channel",
        "BODY": "Izberite ponudnika, ki ga želite povezati s klepetom."
      },
      "INBOX": {
        "TITLE": "Create Inbox",
        "BODY": "Authenticate your account and create an inbox."
      },
      "AGENT": {
        "TITLE": "Add Agents",
        "BODY": "Add agents to the created inbox."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "You are all set to go!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Inbox Name",
        "PLACEHOLDER": "Enter your inbox name (eg: Acme Inc)",
        "ERROR": "Please enter a valid inbox name"
      },
      "WEBSITE_NAME": {
        "LABEL": "Website Name",
        "PLACEHOLDER": "Enter your website name (eg: Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Interno ime",
        "PLACEHOLDER": "Poimenujte nabiralnik, kot je prikazan v nadzorni plošči",
        "ERROR": "Vnesite edinstveno interno ime"
      },
      "FB": {
        "HELP": "PS: S prijavo dobimo dostop samo do sporočil vaše strani. Do vaših zasebnih sporočil nikoli ne moremo dostopati.",
        "CHOOSE_PAGE": "Choose Page",
        "CHOOSE_PLACEHOLDER": "Select a page from the list",
        "INBOX_NAME": "Inbox Name",
        "ADD_NAME": "Add a name for your inbox",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Pick a value",
        "CREATE_INBOX": "Ustvari nabiralnik"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Nadaljuj z Instagramom",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Poveži svoj profil Instagram",
        "HELP": "Če želite dodati svoj profil Instagram kot kanal, morate overiti svoj profil Instagram s klikom na »Nadaljuj z Instagramom« ",
        "ERROR_MESSAGE": "Pri povezovanju z Instagramom je prišlo do napake, poskusite znova",
        "ERROR_AUTH": "Pri povezovanju z Instagramom je prišlo do napake, poskusite znova",
        "NEW_INBOX_SUGGESTION": "Ta račun Instagram je bil prej povezan z drugim nabiralnikom in je bil zdaj premaknjen sem. Vsa nova sporočila se bodo prikazala tukaj. Stari nabiralnik za ta račun ne bo več mogel pošiljati ali prejemati sporočil.",
        "DUPLICATE_INBOX_BANNER": "Ta račun Instagram je bil premaknjen v nov nabiralnik kanala Instagram. Iz tega nabiralnika ne boste več mogli pošiljati/prejemati sporočil Instagram."
      },
      "TWITTER": {
        "HELP": "To add your Twitter profile as a channel, you need to authenticate your Twitter Profile by clicking on 'Sign in with Twitter' ",
        "ERROR_MESSAGE": "There was an error connecting to Twitter, please try again",
        "TWEETS": {
          "ENABLE": "Create conversations from mentioned Tweets"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Website channel",
        "DESC": "Create a channel for your website and start supporting your customers via our website widget.",
        "LOADING_MESSAGE": "Creating Website Support Channel",
        "CHANNEL_AVATAR": {
          "LABEL": "Channel Avatar"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Please enter a valid URL"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Website Domain",
          "PLACEHOLDER": "Enter your website domain (eg: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Welcome Heading",
          "PLACEHOLDER": "Hi there !"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Welcome Tagline",
          "PLACEHOLDER": "We make it simple to connect with us. Ask us anything, or share your feedback."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Channel greeting message",
          "PLACEHOLDER": "Acme Inc typically replies in a few hours."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Enable channel greeting",
          "HELP_TEXT": "Auto-send greeting messages when customers start a conversation and send their first message.",
          "ENABLED": "Enabled",
          "DISABLED": "Disabled"
        },
        "REPLY_TIME": {
          "TITLE": "Set Reply time",
          "IN_A_FEW_MINUTES": "In a few minutes",
          "IN_A_FEW_HOURS": "In a few hours",
          "IN_A_DAY": "In a day",
          "HELP_TEXT": "This reply time will be displayed on the live chat widget"
        },
        "WIDGET_COLOR": {
          "LABEL": "Widget Color",
          "PLACEHOLDER": "Update the widget color used in widget"
        },
        "SUBMIT_BUTTON": "Create inbox",
        "API": {
          "ERROR_MESSAGE": "We were not able to create a website channel, please try again"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp Channel",
        "DESC": "Integrate Twilio and start supporting your customers via SMS or WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Account SID",
          "PLACEHOLDER": "Please enter your Twilio Account SID",
          "ERROR": "This field is required"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "This field is required"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "This field is required"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Messaging Service SID",
          "PLACEHOLDER": "Please enter your Twilio Messaging Service SID",
          "ERROR": "This field is required",
          "USE_MESSAGING_SERVICE": "Use a Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Channel Type",
          "ERROR": "Please select your Channel Type"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth Token",
          "PLACEHOLDER": "Please enter your Twilio Auth Token",
          "ERROR": "This field is required"
        },
        "CHANNEL_NAME": {
          "LABEL": "Inbox Name",
          "PLACEHOLDER": "Please enter a inbox name",
          "ERROR": "This field is required"
        },
        "PHONE_NUMBER": {
          "LABEL": "Phone Number",
          "PLACEHOLDER": "Please enter the phone number from which message will be sent.",
          "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "You have to configure the message callback URL in Twilio with the URL mentioned here."
        },
        "SUBMIT_BUTTON": "Create Twilio Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to authenticate Twilio credentials, please try again"
        }
      },
      "SMS": {
        "TITLE": "SMS Channel",
        "DESC": "Start supporting your customers via SMS.",
        "PROVIDERS": {
          "LABEL": "API Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the SMS channel"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Account ID",
            "PLACEHOLDER": "Please enter your Bandwidth Account ID",
            "ERROR": "This field is required"
          },
          "API_KEY": {
            "LABEL": "API Key",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "This field is required"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "This field is required"
          },
          "APPLICATION_ID": {
            "LABEL": "Application ID",
            "PLACEHOLDER": "Please enter your Bandwidth Application ID",
            "ERROR": "This field is required"
          },
          "INBOX_NAME": {
            "LABEL": "Inbox Name",
            "PLACEHOLDER": "Please enter a inbox name",
            "ERROR": "This field is required"
          },
          "PHONE_NUMBER": {
            "LABEL": "Phone number",
            "PLACEHOLDER": "Please enter the phone number from which message will be sent.",
            "ERROR": "Please provide a valid phone number that starts with a `+` sign and does not contain any spaces."
          },
          "SUBMIT_BUTTON": "Create Bandwidth Channel",
          "API": {
            "ERROR_MESSAGE": "We were not able to authenticate Bandwidth credentials, please try again"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "You have to configure the message callback URL in Bandwidth with the URL mentioned here."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Ime nabiralnika",
            "PLACEHOLDER": "Vnesite ime nabiralnika",
            "ERROR": "To polje je obvezno"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonska številka",
            "PLACEHOLDER": "Vnesite telefonsko številko, s katere bodo poslana sporočila.",
            "ERROR": "Vnesite veljavno telefonsko številko, ki se začne z znakom `+`."
          },
          "SUBMIT_BUTTON": "Ustvari kanal SMS Brana",
          "API": {
            "ERROR_MESSAGE": "Kanala SMS Brana ni bilo mogoče ustvariti"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Ime nabiralnika",
            "PLACEHOLDER": "Vnesite ime nabiralnika",
            "ERROR": "To polje je obvezno"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonska številka",
            "PLACEHOLDER": "Vnesite telefonsko številko, s katere bodo poslana sporočila.",
            "ERROR": "Vnesite veljavno telefonsko številko, ki se začne z znakom `+`."
          },
          "SUBMIT_BUTTON": "Ustvari kanal DIDWW",
          "API": {
            "ERROR_MESSAGE": "Kanala DIDWW ni bilo mogoče ustvariti"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API Provider",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "You have to configure the webhook URL and the verification token in the Facebook Developer portal with the values shown below.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Verification Token"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Hitra nastavitev z Meto",
          "DESC": "Preusmerjeni boste na Meto, kjer se prijavite v svoj račun WhatsApp Business. Skrbniški dostop bo omogočil hitrejšo in lažjo nastavitev.",
          "BENEFITS": {
            "EASY_SETUP": "Ročna nastavitev ni potrebna",
            "SECURE_AUTH": "Varna avtentikacija na osnovi OAuth",
            "AUTO_CONFIG": "Samodejna nastavitev webhooka in telefonske številke"
          },
          "SUBMIT_BUTTON": "Poveži z WhatsApp Business",
          "AUTH_PROCESSING": "Avtentikacija z Meto",
          "WAITING_FOR_BUSINESS_INFO": "Dokončajte nastavitev podjetja v oknu Meta ...",
          "PROCESSING": "Nastavljanje vašega računa WhatsApp Business",
          "CANCELLED": "Prijava v WhatsApp je bila preklicana",
          "WAITING_FOR_AUTH": "Čakanje na avtentikacijo ...",
          "INVALID_BUSINESS_DATA": "Od Facebooka so bili prejeti neveljavni podatki o podjetju. Poskusite znova.",
          "SIGNUP_ERROR": "Prišlo je do napake pri prijavi",
          "SDK_LOAD_ERROR": "Facebook SDK ni bilo mogoče naložiti. Poskusite znova.",
          "AUTH_NOT_COMPLETED": "Avtentikacija ni bila dokončana. Ponovno zaženite postopek.",
          "SUCCESS_FALLBACK": "Račun WhatsApp Business je bil uspešno nastavljen",
          "RECONNECTED": "Kanal WhatsApp je bil uspešno znova povezan"
        },
        "API": {
          "ERROR_MESSAGE": "We were not able to save the WhatsApp channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API Channel",
        "DESC": "Integrate with API channel and start supporting your customers.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Create API Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the api channel"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Kanal Salesforce",
        "DESC": "Povežite se s kanalom Salesforce in začnite podpirati svoje stranke.",
        "CHANNEL_NAME": {
          "LABEL": "Ime kanala",
          "PLACEHOLDER": "Vnesite ime kanala",
          "ERROR": "To polje je obvezno"
        },
        "API_BASE_URL": {
          "LABEL": "URL API-ja Salesforce",
          "SUBTITLE": "Nastavite osnovni URL za svojo instanco Salesforce.",
          "PLACEHOLDER": "URL API-ja Salesforce"
        },
        "KEY_ID": {
          "LABEL": "ID ključa",
          "SUBTITLE": "ID ključa za vaš kanal Salesforce.",
          "PLACEHOLDER": "ID KLJUČA"
        },
        "SECRET": {
          "LABEL": "Skrivnost",
          "SUBTITLE": "Skrivnost za vaš kanal Salesforce.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Ustvari kanal Salesforce",
        "API": {
          "ERROR_MESSAGE": "Kanala Salesforce ni bilo mogoče shraniti"
        },
        "API_CALLBACK": {
          "TITLE": "URL webhooka",
          "SUBTITLE": "V Salesforceu morate nastaviti URL webhooka na URL, naveden tukaj."
        },
        "BEARER_TOKEN": {
          "TITLE": "Žeton Bearer",
          "SUBTITLE": "Ta žeton Bearer uporabite za avtentikacijo pri nastavitvi webhooka v Salesforceu."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Prepiši pošiljatelja e-pošte",
          "SUBTITLE": "Če je nastavljen, se ta e-poštni naslov uporabi kot pošiljatelj za vsa odhodna sporočila namesto izvornega e-poštnega naslova pogovora.",
          "PLACEHOLDER": "npr. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Kanal Allegro",
        "DESC": "Povežite prodajni račun Allegro in iz kontaktnega centra odgovarjajte na sporočila v njegovem središču za sporočila.",
        "CHANNEL_NAME": {
          "LABEL": "Ime nabiralnika",
          "SUBTITLE": "Ime, ki ga agenti vidijo za ta nabiralnik.",
          "PLACEHOLDER": "Vnesite ime nabiralnika",
          "ERROR": "To polje je obvezno"
        },
        "SUBMIT_BUTTON": "Prijavite se prek Allegra",
        "API": {
          "ERROR_MESSAGE": "Pri povezovanju z Allegrom je prišlo do napake, poskusite znova"
        },
        "SELLER_LOGIN": {
          "TITLE": "Prijava v Allegro",
          "SUBTITLE": "Prodajni račun, za katerega ta nabiralnik bere sporočila in nanje odgovarja."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kanal Kaufland",
        "DESC": "Odgovarjajte na sporočila v zahtevkih, ki vam jih kupci pošljejo na tržnici Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Ime kanala",
          "PLACEHOLDER": "Vnesite ime kanala",
          "ERROR": "To polje je obvezno"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "Client Key z 32 znaki s strani nastavitev API vašega prodajnega računa Kaufland.",
          "PLACEHOLDER": "ključ z 32 znaki",
          "ERROR": "Vnesite Client Key z 32 znaki"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "Secret Key s 64 znaki, ki pripada ključu Client Key. Kaufland ga prikaže enkrat in nikoli ni poslan nazaj na to stran.",
          "PLACEHOLDER": "ključ s 64 znaki",
          "ERROR": "Vnesite Secret Key s 64 znaki"
        },
        "SUBMIT_BUTTON": "Ustvari kanal Kaufland",
        "API": {
          "ERROR_MESSAGE": "Kanala Kaufland ni bilo mogoče shraniti"
        },
        "DISCONNECTED": {
          "TITLE": "Ni povezave",
          "MESSAGE": "Kaufland je zavrnil te ključe API. Znova vnesite Client Key in Secret Key, da ponovno povežete ta nabiralnik."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Email Channel",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "EMAIL": {
          "LABEL": "E-pošta",
          "SUBTITLE": "Provide the email address where your customers send support requests.",
          "PLACEHOLDER": "E-pošta"
        },
        "SUBMIT_BUTTON": "Create Email Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the email channel"
        },
        "FINISH_MESSAGE": "Start forwarding your emails to the following email address."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE Channel",
        "DESC": "Integrate with LINE channel and start supporting your customers.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE Channel ID",
          "PLACEHOLDER": "LINE Channel ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Channel Secret",
          "PLACEHOLDER": "LINE Channel Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Channel Token",
          "PLACEHOLDER": "LINE Channel Token"
        },
        "SUBMIT_BUTTON": "Create LINE Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the LINE channel"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "You have to configure the webhook URL in LINE application with the URL mentioned here."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram Channel",
        "DESC": "Integrate with Telegram channel and start supporting your customers.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Configure the bot token you have obtained from Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Create Telegram Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the telegram channel"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Telefonski klici",
        "DESC": "Nastavite, kateri telefonski klici se bodo prikazali v tem nabiralniku.",
        "NAME": {
          "LABEL": "Ime nabiralnika",
          "SUBTITLE": "Izberite lahko prepoznavno ime."
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonska številka",
          "SUBTITLE": "Vnesite telefonske številke, ki pripadajo temu nabiralniku, več številk lahko dodate pozneje.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Ustvari nabiralnik za telefonske klice",
        "API": {
          "ERROR_MESSAGE": "Nabiralnika ni bilo mogoče ustvariti"
        }
      },
      "AUTH": {
        "TITLE": "Choose a channel",
        "DESC": "Klepet podpira pripomočke za klepet v živo, Facebook Messenger, WhatsApp, e-pošto itd. kot kanale. Če želite zgraditi kanal po meri, ga lahko ustvarite s kanalom API. Za začetek izberite enega od spodnjih kanalov."
      },
      "AGENTS": {
        "TITLE": "Agents",
        "DESC": "Here you can add agents to manage your newly created inbox. Only these selected agents will have access to your inbox. Agents which are not part of this inbox will not be able to see or respond to messages in this inbox when they login. <br> <b>PS:</b> As an administrator, if you need access to all inboxes, you should add yourself as agent to all inboxes that you create.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Pick agents for the inbox"
      },
      "DETAILS": {
        "TITLE": "Inbox Details",
        "DESC": "V spodnjem spustnem seznamu izberite Facebook stran, ki jo želite povezati s klepetom. Svojemu nabiralniku lahko za lažjo prepoznavo dodelite tudi ime po meri."
      },
      "FINISH": {
        "TITLE": "Nailed It!",
        "DESC": "Uspešno ste povezali svojo Facebook stran s klepetom. Ko bo stranka naslednjič pisala vaši strani, se bo pogovor samodejno prikazal v vašem nabiralniku.<br>Na voljo vam je tudi skripta pripomočka, ki jo lahko preprosto dodate na svojo spletno stran. Ko bo ta aktivna na vaši spletni strani, vam bodo stranke lahko pisale neposredno z vaše spletne strani brez zunanjega orodja, pogovor pa se bo prikazal prav tukaj, v klepetu.<br>Super, kajne? No, vsaj trudimo se :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Select your email provider",
        "DESCRIPTION": "Select an email provider from the list below. If you don't see your email provider in the list, you can select the other provider option and provide the IMAP and SMTP Credentials."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Click on the Sign in with Microsoft button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "There was an error connecting to Microsoft, please try again"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Enter email address",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Authenticating you with Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Something went wrong, Please refresh page...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "Nabiralnika ni bilo mogoče ustvariti. Poskusite znova.",
      "CREATING_CHANNEL": "Creating your Inbox...",
      "TITLE": "Configure Inbox Details",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Add agents",
      "ADD_AGENTS": "Adding Agents to your Inbox..."
    },
    "FINISH": {
      "TITLE": "Your Inbox is ready!",
      "MESSAGE": "You can now engage with your customers through your new Channel. Happy supporting",
      "BUTTON_TEXT": "Take me there",
      "MORE_SETTINGS": "More settings",
      "WEBSITE_SUCCESS": "You have successfully finished creating a website channel. Copy the code shown below and paste it on your website. Next time a customer use the live chat, the conversation will automatically appear on your inbox."
    },
    "REAUTH": "Reauthorize",
    "VIEW": "View",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Inbox settings updated successfully",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Auto assignment updated successfully",
        "ERROR_MESSAGE": "We couldn't update inbox settings. Please try again later."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Omogočeno",
        "DISABLED": "Onemogočeno"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Friendly",
          "FROM": "Od",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Professional",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Save"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Brez"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "ENABLE_HMAC": {
        "LABEL": "Enable"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Omogočeno",
        "DISABLED": "Onemogočeno"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Omogočeno",
        "DISABLED": "Onemogočeno"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Omogoči sinhronizacijo dohodnih e-poštnih sporočil"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Omogoči domeno e-pošte po meri (plačljiva storitev)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Omogoči obdelavo komentarjev Facebook"
      },
      "SIGNATURE": {
        "TITLE": "Podpis HTML",
        "SUB_TEXT": "Ta podpis bo dodan v nogo vsakega sporočila, poslanega iz tega nabiralnika.",
        "HTML_CONTENT": "Koda HTML",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} bo nadomeščen z imenom agenta.\n{'{{'}email{'}}'} bo nadomeščen z e-poštnim naslovom agenta, ki je poslal e-pošto.\n{'{{'}position{'}}'} bo nadomeščen s položajem agenta.\n{'{{'}custom_line{'}}'} bo nadomeščen z agentovo vrstico po meri.\n{'{{'}email_signature_picture{'}}'} bo nadomeščen z URL-jem agentove slike e-poštnega podpisa (ni oznaka slike) — uporabite ga kot vir slike (atribut src oznake img).",
        "PREVIEW": "Predogled"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Podpisi po državah",
        "SUB_TEXT": "Odgovor dobi podpis glede na državo kupca.",
        "HELP": "Odgovor se podpiše glede na državo pogovora: glede na trgovino Kaufland, glede na tržnico naročila Allegro, sicer glede na jezik, v katerem piše kupec. Če države ne prepoznamo ali zanjo tu ni podpisa, se uporabi podpis HTML zgoraj. Tržnice prepovedujejo povezave na vaše spletno mesto in kontaktne podatke, zato navedite samo pozdrav in {'{{'}name{'}}'}.",
        "EMPTY": "Podpisov za posamezne države še nimate, zato odgovori uporabijo podpis HTML zgoraj.",
        "COUNTRY": "Izberite državo",
        "ADD": "Dodaj podpis za državo",
        "REMOVE": "Odstrani"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Klicna predpona telefonske številke",
        "PLACEHOLDER": "Vnesite predpono za pravilno usmerjanje klicev (npr. *99)",
        "HELP_TEXT": "Ta predpona bo samodejno dodana pred telefonske številke kontaktov pri klicanju iz tega nabiralnika."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Besedilo gumba »Rešimo pozneje«",
        "PLACEHOLDER": "npr. To temo bomo rešili po e-pošti. Zdaj bi rad vprašal o nečem drugem.",
        "HELP_TEXT": "Oznaka gumba v pripomočku, s katerim obiskovalec zapusti trenutno temo in vpraša o nečem drugem. Če polje pustite prazno, se uporabi privzeto besedilo v jeziku obiskovalca."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Samodejno odloži zgrešene klice za X minut",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Samodejno odloži zgrešene klice za navedeno število minut. Pustite prazno ali 0, da onemogočite."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Razreši zgrešen klic po X neuspešnih povratnih klicih",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Ko se stranka na zgrešen klic X-krat ne odzove na povratni klic, se ta samodejno razreši in doda se zasebna opomba. Pustite prazno ali 0, da onemogočite."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Predlogi vprašanj",
        "SUB_TEXT": "Nastavite vnaprej določena vprašanja, ki jih lahko stranke uporabijo za interakcijo z vašimi agenti.",
        "QUESTIONS_LABEL": "Vprašanja",
        "ADD_QUESTION": "Dodaj vprašanje",
        "REMOVE": "Odstrani",
        "QUESTION_TEXT": "Besedilo, prikazano v oblačku.",
        "QUESTION_TEXT_PLACEHOLDER": "Obvezno",
        "QUESTION_PAYLOAD": "Besedilo, poslano ob kliku.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Neobvezno",
        "NO_BOT_MESSAGE": "Za ustvarjanje dodatnih predlogov UI povežite bota.",
        "BOT_CONNECTED_MESSAGE": "Predloge vprašanj UI od bota lahko aktivirate v njegovih",
        "BOT_SETTINGS_LINK": "nastavitvah"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Nadomestni e-poštni naslovi",
        "SUB_TEXT": "Dodatni naslovi, ki naj jih ta nabiralnik obravnava kot svoje pri prejemanju posredovane pošte.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Dodaj",
        "REMOVE": "Odstrani",
        "EMPTY": "Nastavljenih ni nobenih nadomestnih e-poštnih naslovov.",
        "HELP_TEXT": "Ko prispe e-pošta z enim od teh naslovov kot prejemnikom, bodo odgovori poslani z istega naslova kot pošiljatelja. Prepričajte se, da vaš odhodni strežnik SMTP dovoljuje pošiljanje s teh naslovov.",
        "SIGNATURE_LABEL": "Podpis",
        "PRIMARY_SIGNATURE": "Primarni (privzeto)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Dodatni podpisi",
        "SUB_TEXT": "Tukaj določite dodatne podpise, nato pa jih dodelite spodnjim nadomestnim e-poštnim naslovom.",
        "OPTION": "Podpis {number}",
        "ADD": "Dodaj podpis",
        "REMOVE": "Odstrani",
        "HELP_TEXT": "Ko je odgovor poslan z nadomestnega e-poštnega naslova, se namesto podpisa nabiralnika uporabi podpis, dodeljen temu naslovu. Nadomestni e-poštni naslovi, ki ostanejo na »Primarni (privzeto)«, uporabijo podpis nabiralnika."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Delete",
      "AVATAR_DELETE_BUTTON_TEXT": "Delete Avatar",
      "DELETE_REQUESTED_TOOLTIP": "Ta nabiralnik je označen za izbris",
      "RESTORE_BUTTON_TEXT": "Obnovi",
      "CONFIRM": {
        "TITLE": "Confirm Deletion",
        "MESSAGE": "Are you sure to delete ",
        "PLACE_HOLDER": "Please type {inboxName} to confirm",
        "YES": "Yes, Delete ",
        "NO": "No, Keep "
      },
      "API": {
        "SUCCESS_MESSAGE": "Inbox deleted successfully",
        "MARKED_FOR_DELETION_MESSAGE": "Nabiralnik je označen za izbris",
        "RESTORE_SUCCESS_MESSAGE": "Nabiralnik je bil uspešno obnovljen",
        "ERROR_MESSAGE": "Could not delete inbox. Please try again later.",
        "RESTORE_ERROR_MESSAGE": "Nabiralnika ni bilo mogoče obnoviti. Poskusite znova pozneje.",
        "AVATAR_SUCCESS_MESSAGE": "Inbox avatar deleted successfully",
        "AVATAR_ERROR_MESSAGE": "Could not delete the inbox avatar. Please try again later."
      }
    },
    "TABS": {
      "SETTINGS": "Settings",
      "COLLABORATORS": "Collaborators",
      "AUTOMATIC_PRIORITY": "Samodejna prioriteta",
      "AUTOMATIC_LABELING": "Samodejno označevanje",
      "CONFIGURATION": "Configuration",
      "CAMPAIGN": "Campaigns",
      "PRE_CHAT_FORM": "Pre Chat Form",
      "BUSINESS_HOURS": "Business Hours",
      "WIDGET_BUILDER": "Widget Builder",
      "BOT_CONFIGURATION": "Bot Configuration",
      "SLA": "SLA"
    },
    "SETTINGS": "Settings",
    "FEATURES": {
      "LABEL": "Features",
      "DISPLAY_FILE_PICKER": "Display file picker on the widget",
      "DISPLAY_EMOJI_PICKER": "Display emoji picker on the widget",
      "ALLOW_END_CONVERSATION": "Allow users to end conversation from the widget",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Prikaži gumb 'Začni nov pogovor' v glavi pripomočka",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Hide input field when start new conversation button is shown",
      "SHOW_HANDOFF_BUTTON": "Prikaži gumb 'Predaj operaterju' v glavi pripomočka",
      "AUTO_CLOSE_OLD": "Ko je en klic rešen, označi vse pretekle klice z iste številke kot rešene",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Samodejno dodeli zgrešene klice ob izhodnem klicu",
      "USE_INBOX_AVATAR_FOR_BOT": "Use inbox name and avatar for the bot",
      "ALLOW_OFFLINE_REPLY": "Agentom dovoli pošiljanje sporočil, ko kontakt ni na spletu in nadaljevanje prek e-pošte ni na voljo"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger Script",
      "MESSENGER_SUB_HEAD": "Place this button inside your body tag",
      "INBOX_AGENTS": "Agents",
      "INBOX_TEAMS": "Ekipe",
      "INBOX_COOPERATORS": "Sodelavci",
      "SELECT_PLACEHOLDER": "Izberite",
      "AGENTS_OR_TEAMS_INFO": "Dodelite lahko bodisi agente bodisi ekipe – ne obojega hkrati.",
      "INBOX_AGENTS_SUB_TEXT": "Add or remove agents from this inbox",
      "AGENT_ASSIGNMENT": "Conversation Assignment",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Update conversation assignment settings",
      "UPDATE": "Update",
      "ENABLE_EMAIL_COLLECT_BOX": "Enable email collect box",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Enable or disable email collect box on new conversation",
      "AUTO_ASSIGNMENT": "Enable auto assignment",
      "ENABLE_CSAT": "Enable CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Omogoči CSAT pri vsakem sporočilu",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "ENABLE_CSAT_SUB_TEXT": "Enable/Disable CSAT(Customer satisfaction) survey after resolving a conversation",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Omogoči/onemogoči anketo CSAT za vsako sporočilo, ki ga pošlje agent",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Enable conversation continuity via email",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Conversations will continue over email if the contact email address is available.",
      "RESPOND_FROM_EMAIL": "Odgovori iz e-pošte",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "E-poštna sporočila stranki — tako odgovori kot prepisi pogovorov — so poslana z nastavitvami SMTP izbranega e-poštnega nabiralnika, z izbranega naslova (lastnega naslova nabiralnika ali enega od njegovih aliasov), odgovori stranke pa prispejo nazaj prek njegovega naslova IMAP.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Prepisi pogovorov so poslani z nastavitvami SMTP izbranega e-poštnega nabiralnika, z izbranega naslova (lastnega naslova nabiralnika ali enega od njegovih aliasov), odgovori pa prispejo nazaj prek njegovega naslova IMAP.",
      "SHOW_WELCOME_SCREEN": "Prikaži pozdravni zaslon",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Prikaži pozdravni zaslon, ko se widget odpre. Če je onemogočeno, widget preide neposredno na pogled pogovora.",
      "AUTO_CLOSE_PENDING": "Samodejno reši klepete UI po (urah)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Samodejno reši klepete UI po X urah nedejavnosti.",
      "LOCK_TO_SINGLE_CONVERSATION": "Lock to single conversation",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Enable or disable multiple conversations for the same contact in this inbox",
      "INBOX_UPDATE_TITLE": "Inbox Settings",
      "INBOX_UPDATE_SUB_TEXT": "Update your inbox settings",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Enable or disable the automatic assignment of new conversations to the agents added to this inbox.",
      "HMAC_VERIFICATION": "User Identity Validation",
      "HMAC_DESCRIPTION": "With this key you can generate a secret token that can be used to verify the identity of your users.",
      "HMAC_ROTATE": {
        "BUTTON": "Zamenjaj ključ",
        "TITLE": "Želite zamenjati skrivni ključ?",
        "WARNING": "Trenutni ključ je preklican takoj, ko ga zamenjate.",
        "WARNING_DETAIL": "Obdobja prekrivanja ni, ključa pa ni mogoče obnoviti.",
        "IMPACT": "Vaši strežniki morajo uporabnike podpisovati z novim ključem. Kdor je še podpisan s starim, ne opravi preverjanja. Če je preverjanje identitete obvezno, ne more začeti pogovora.",
        "CONFIRM": "Zamenjaj ključ",
        "CANCEL": "Prekliči",
        "SUCCESS": "Skrivni ključ je bil uspešno zamenjan",
        "ERROR": "Skrivnega ključa ni bilo mogoče zamenjati, poskusite znova"
      },
      "HMAC_LINK_TO_DOCS": "You can read more here.",
      "HMAC_MANDATORY_VERIFICATION": "Enforce User Identity Validation",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests that cannot be verified will be rejected.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Vsili nov pogovor ob vsakem nalaganju widgeta",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Če je omogočeno, odpiranje widgeta v novem zavihku ali oknu začne nov pogovor.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Pozabi kontakt, ko se začne nov pogovor",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Če je onemogočeno, nov pogovor, začet iz widgeta, ohrani prejšnji kontakt.",
      "INBOX_IDENTIFIER": "Inbox Identifier",
      "INBOX_IDENTIFIER_SUB_TEXT": "Use the `inbox_identifier` token shown here to authentication your API clients.",
      "FORWARD_EMAIL_TITLE": "Forward to Email",
      "FORWARD_EMAIL_SUB_TEXT": "Start forwarding your emails to the following email address.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Sinhronizacija e-pošte",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Omogoči samodejno sinhronizacijo in prenos dohodnih e-poštnih sporočil iz tega nabiralnika",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Domena e-pošte po meri",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Omogoči uporabo domene e-pošte po meri za odhodna sporočila",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Več o tem lahko preberete tukaj.",
      "FACEBOOK_COMMENTS_TITLE": "Komentarji Facebook",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Allow messages after conversation resolved",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Allow the end-users to send messages even after the conversation is resolved.",
      "WIDGET_STATUS_LABEL": "Stanje widgeta",
      "WIDGET_STATUS_ENABLED": "Omogočeno",
      "WIDGET_STATUS_BUSINESS_HOURS": "Omogočeno v poslovnem času",
      "WIDGET_STATUS_DISABLED": "Onemogočeno",
      "WIDGET_STATUS_HELP_TEXT": "Nadzirajte, kdaj se widget prikaže obiskovalcem na vaši spletni strani",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Update Pre Chat Form Settings",
      "EXPLICIT_CSAT_LOCALE": "Jezik ankete CSAT in e-pošte",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Izberite jezik za vsa e-poštna sporočila strankam, vključno z anketami CSAT, prepisi pogovorov in e-poštnimi obvestili",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Podeduj iz računa",
      "WHATSAPP_CONNECTION": {
        "TITLE": "Povezava WhatsApp",
        "SUBTITLE": "Kako je ta nabiralnik povezan z WhatsAppom.",
        "PROVIDER": "Ponudnik",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Povezano prek vgrajene registracije Meta",
        "STATUS": "Stanje",
        "CONNECTED": "Povezano",
        "RECONNECT_HINT": "Kliknite Ponovno poveži v obvestilu zgoraj.",
        "PHONE_NUMBER": "Telefonska številka",
        "BUSINESS_ACCOUNT": "ID računa WhatsApp Business",
        "OPEN_MANAGER": "Odpri v WhatsApp Managerju",
        "PHONE_NUMBER_ID": "ID telefonske številke",
        "TEMPLATES": "Predloge sporočil",
        "TEMPLATES_COUNT": "Odobrenih {approved} od {total}",
        "TEMPLATES_SYNCED": "Zadnja sinhronizacija: {date}",
        "TEMPLATES_NOT_SYNCED": "Še ni sinhronizirano",
        "MANAGE_TEMPLATES": "Upravljaj predloge"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Help Center",
      "PLACEHOLDER": "Select Help Center",
      "SELECT_PLACEHOLDER": "Select Help Center",
      "REMOVE": "Remove Help Center",
      "SUB_TEXT": "Attach a Help Center with the inbox"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Auto assignment limit",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Please enter a value greater than 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limit the maximum number of conversations from this inbox that can be auto assigned to an agent"
    },
    "SLA": {
      "TITLE": "Politike SLA",
      "SUB_TEXT": "Nastavite čase odziva in rešitve SLA za vsako raven prioritete pogovora.",
      "LOADING": "Nalaganje politik SLA ...",
      "FIELDS": {
        "ACTIVE": "Aktivno",
        "TICKET_PRIORITY": "Prioriteta zahtevka",
        "FIRST_RESPONSE_TIME": "Čas prvega odziva",
        "EVERY_RESPONSE_TIME": "Čas vsakega odziva",
        "RESOLUTION_TIME": "Čas rešitve",
        "PLACEHOLDER": "npr. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "Politike SLA so bile uspešno posodobljene.",
        "ERROR_MESSAGE": "Politik SLA ni bilo mogoče posodobiti. Poskusite znova."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Samodejna prioriteta",
      "SUB_TEXT": "Nastavite samodejno dodeljevanje prioritete na podlagi vsebine pogovora.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Obvestilo o zaračunavanju",
        "MESSAGE": "Vsaka ocena prioritete povzroči strošek. Podrobnosti o cenah preverite v podatkih o svojem paketu."
      },
      "MODE": {
        "OFF": "Izklopljeno",
        "ALL_MESSAGES": "Vklopljeno za vsa dohodna sporočila",
        "FIRST_MESSAGE": "Vklopljeno samo za prvo dohodno sporočilo"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Nastavitev ravni prioritete",
        "SUB_TEXT": "Nastavite, katere ravni prioritete naj bodo omogočene, in njihove opise. Navedite jasna merila, po katerih UI določi, kdaj naj se dodeli ta prioriteta."
      },
      "DESCRIPTION_LABEL": "Opis",
      "DESCRIPTION_PLACEHOLDER": "Opišite pogovore, ki naj se označijo s prioriteto {priority}",
      "SET_AS_DEFAULT": "Nastavi kot privzeto prioriteto",
      "MULTIPLE_DEFAULTS_WARNING": "Kot privzeta sme biti nastavljena samo ena raven prioritete. Odznačite druge privzete ravni."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Samodejno označevanje",
      "SUB_TEXT": "Nastavite samodejno dodeljevanje oznak na podlagi vsebine pogovora.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Obvestilo o zaračunavanju",
        "MESSAGE": "Vsaka ocena označevanja povzroči strošek. Podrobnosti o cenah preverite v podatkih o svojem paketu."
      },
      "MODE": {
        "OFF": "Izklopljeno",
        "CONVERSATION_OPEN": "Ob odprtju pogovora",
        "CONVERSATION_CLOSE": "Ob zaprtju pogovora",
        "ALL_MESSAGES": "Ob vsakem sporočilu – ne glede na stanje",
        "FIRST_MESSAGE": "Ob prvem sporočilu – ne glede na stanje"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Nastavitev oznak",
        "SUB_TEXT": "Nastavite, katere oznake naj bodo na voljo za samodejno dodeljevanje, in njihove opise. Navedite jasna merila, po katerih UI določi, kdaj naj se uporabi ta oznaka."
      },
      "DESCRIPTION_LABEL": "Opis",
      "DESCRIPTION_PLACEHOLDER": "Opišite pogovore, ki naj se označijo z oznako {label}. Če pustite prazno, bo uporabljen opis oznake.",
      "NO_LABELS_MESSAGE": "Ni najdenih oznak. Najprej ustvarite oznake, da omogočite samodejno označevanje.",
      "CREATE_LABELS_LINK": "Ustvari oznake"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Reauthorize",
      "SUBTITLE": "Your Facebook connection has expired, please reconnect your Facebook page to continue services",
      "MESSAGE_SUCCESS": "Reconnection successful",
      "MESSAGE_ERROR": "There was an error, please try again"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Pre chat forms enable you to capture user information before they start conversation with you.",
      "SET_FIELDS": "Pre chat form fields",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Fields",
        "LABEL": "Label",
        "PLACE_HOLDER": "Placeholder",
        "KEY": "Key",
        "TYPE": "Type",
        "REQUIRED": "Required"
      },
      "ENABLE": {
        "LABEL": "Enable pre chat form",
        "OPTIONS": {
          "ENABLED": "Yes",
          "DISABLED": "No"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pre chat message",
        "PLACEHOLDER": "This message would be visible to the users along with the form"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Visitors should provide their name and email address before starting the chat"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Set your availability",
      "SUBTITLE": "Set your availability on your livechat widget",
      "WEEKLY_TITLE": "Set your weekly hours",
      "TIMEZONE_LABEL": "Select timezone",
      "UPDATE": "Update business hours settings",
      "TOGGLE_AVAILABILITY": "Enable business availability for this inbox",
      "UNAVAILABLE_MESSAGE_LABEL": "Unavailable message for visitors",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "ENABLE": "Enable availability for this day",
        "UNAVAILABLE": "Unavailable",
        "HOURS": "hours",
        "VALIDATION_ERROR": "Starting time should be before closing time.",
        "CHOOSE": "Choose"
      },
      "ALL_DAY": "All-Day",
      "SAVE_TO_ALL": "Shrani v vse nabiralnike",
      "SAVE_TO_ALL_TITLE": "Kopiraj delovni čas",
      "SAVE_TO_ALL_CONFIRM": "Nastavitve iz tega obrazca (stikalo razpoložljivosti, sporočilo o odsotnosti, časovni pas in delovni čas) bodo kopirane v vse druge nabiralnike, razen v e-poštne in telefonske nabiralnike. Ali ste prepričani, da želite nadaljevati?",
      "SAVE_TO_ALL_CANCEL": "Prekliči",
      "SAVE_TO_ALL_YES": "Da, kopiraj v vse",
      "SAVE_TO_ALL_SUCCESS": "Delovni čas je bil uspešno kopiran v vse druge nabiralnike",
      "SAVE_TO_ALL_ERROR": "Kopiranje delovnega časa v druge nabiralnike ni uspelo"
    },
    "PHONE": {
      "TITLE": "Nastavitve telefona",
      "SUBTITLE": "Nastavite, kateri klici se bodo prikazali v tem nabiralniku.",
      "UPDATE": "Shrani nastavitve",
      "EDIT": {
        "SUCCESS_MESSAGE": "Nastavitve telefona posodobljene"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Telefonske številke",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Set your IMAP details",
      "NOTE_TEXT": "To enable SMTP, please configure IMAP.",
      "UPDATE": "Update IMAP settings",
      "TOGGLE_AVAILABILITY": "Enable IMAP configuration for this inbox",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update IMAP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Prijava",
        "PLACE_HOLDER": "Prijava"
      },
      "PASSWORD": {
        "LABEL": "Geslo",
        "PLACE_HOLDER": "Geslo"
      },
      "ENABLE_SSL": "Enable SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reauthorize your MICROSOFT account"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Set your SMTP details",
      "UPDATE": "Update SMTP settings",
      "TOGGLE_AVAILABILITY": "Enable SMTP configuration for this inbox",
      "TOGGLE_HELP": "Enabling SMTP will help the user to send email",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP settings updated successfully",
        "ERROR_MESSAGE": "Unable to update SMTP settings"
      },
      "ADDRESS": {
        "LABEL": "Address",
        "PLACE_HOLDER": "Address (Eg: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Prijava",
        "PLACE_HOLDER": "Prijava"
      },
      "PASSWORD": {
        "LABEL": "Geslo",
        "PLACE_HOLDER": "Geslo"
      },
      "DOMAIN": {
        "LABEL": "Domain",
        "PLACE_HOLDER": "Domain"
      },
      "ENCRYPTION": "Encryption",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL Verify Mode",
      "AUTH_MECHANISM": "Authentication"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Dostava e-pošte (DNS)",
      "SUB_TITLE": "Zapise SPF, DKIM, DMARC in MX za {domain} preverimo vsak delovni dan. Če zaradi česa sprejemni strežniki vaše odgovore zavračajo ali jih uvrščajo med vsiljeno pošto, skrbniki prejmejo e-sporočilo z navodili za popravek.",
      "RUN": "Zaženi preverjanje",
      "RUN_SUCCESS": "Preverjanje DNS je končano",
      "RUN_ERROR": "Preverjanja DNS ni bilo mogoče zagnati, poskusite znova",
      "NOT_CHECKED": "Še ni preverjeno.",
      "CHECKED_AT": "Zadnje preverjanje: {time}.",
      "DNS_UNAVAILABLE": "Imenski strežniki domene pri zadnjem preverjanju niso odgovorili. Spodnji rezultat je iz prejšnjega preverjanja.",
      "SENDER": {
        "SMTP": "Odgovori se pošiljajo prek {host}.",
        "PLATFORM": "Odgovori se pošiljajo prek naših poštnih strežnikov."
      },
      "STATUS": {
        "OK": "Vsi zapisi so v redu",
        "WARNING": "Nekatere zapise bi bilo dobro izboljšati",
        "ERROR": "Odgovori morda ne bodo prispeli do prejemnikov",
        "UNKNOWN": "Neznano"
      },
      "SEVERITY": {
        "ERROR": "Težava",
        "WARNING": "Opozorilo"
      },
      "FIX": "Odpravite jo s tem zapisom DNS:",
      "RECORD_TYPE": "Vrsta",
      "RECORD_HOST": "Ime",
      "RECORD_VALUE": "Vrednost",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "Zapis SPF manjka",
          "DESCRIPTION": "Domena ne določa, kateri strežniki smejo pošiljati njeno e-pošto. Številni poštni strežniki zato vaše odgovore obravnavajo kot vsiljeno pošto. Dodajte zapis SPF, ki dovoljuje {sender}."
        },
        "spf_multiple": {
          "TITLE": "Domena ima {count} zapisov SPF",
          "DESCRIPTION": "Domena sme imeti samo en zapis SPF. Pri več zapisih sprejemni strežniki SPF prezrejo in pošto pogosto zavrnejo. Združite jih v en sam zapis."
        },
        "spf_not_authorized": {
          "TITLE": "SPF ne dovoljuje strežnika, ki pošilja vaše odgovore",
          "DESCRIPTION": "Vaši odgovori se pošiljajo prek {sender}, vendar ga zapis SPF domene ne navaja. Trenutni zapis: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "Zapis SPF zahteva preveč poizvedb DNS",
          "DESCRIPTION": "Sprejemni strežniki preverjanje SPF prekinejo po {limit} poizvedbah DNS, vendar je {sender}, prek katerega se pošiljajo vaši odgovori, na vrsti šele po {lookups}. Vaši odgovori zato ne prestanejo preverjanja SPF. Premaknite {sender} na začetek zapisa in odstranite vnose include, ki jih domena ne uporablja več."
        },
        "spf_lookups_others": {
          "TITLE": "Nekateri pošiljatelji v zapisu SPF presegajo omejitev poizvedb",
          "DESCRIPTION": "Zapis SPF zahteva {lookups} poizvedb DNS, sprejemni strežniki se ustavijo po {limit}. Vaši odgovori so prepoznani pravočasno in preverjanje prestanejo, pošta teh pošiljateljev pa preverjanja SPF ne prestane: {senders}. Odstranite vnose include, ki jih domena ne uporablja več."
        },
        "spf_malformed": {
          "TITLE": "Zapis SPF je neveljaven",
          "DESCRIPTION": "Sprejemni strežniki zapisa SPF domene ne morejo prebrati, zato ne ščiti vaših odgovorov. Težava je v: {terms}. Zapis zamenjajte s popravljenim."
        },
        "dkim_missing": {
          "TITLE": "Podpis DKIM ni nastavljen",
          "DESCRIPTION": "Ključa DKIM nismo našli na {selectors}. Brez njega vaši odgovori niso podpisani in laže pristanejo med vsiljeno pošto. Pri ponudniku e-pošte vklopite podpisovanje DKIM za domeno."
        },
        "dmarc_missing": {
          "TITLE": "Zapis DMARC manjka",
          "DESCRIPTION": "Veliki ponudniki e-pošte, kot sta Gmail in Microsoft, pričakujejo zapis DMARC. Brez njega vaši odgovori laže pristanejo med vsiljeno pošto."
        },
        "dmarc_fails": {
          "TITLE": "DMARC prejemnikom nalaga, naj vaše odgovore zavrnejo",
          "DESCRIPTION": "Pravilnik DMARC domene je „{policy}“, vaši odgovori pa ne prestanejo niti preverjanja SPF niti DKIM, zato jih prejemniki zavrnejo ali premaknejo med vsiljeno pošto. Odpravite težave s SPF in DKIM zgoraj."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC blokira odgovore, poslane prek naših poštnih strežnikov",
          "DESCRIPTION": "Ta nabiralnik pošilja odgovore prek naših poštnih strežnikov, vendar je pravilnik DMARC domene „{policy}“, zato jih prejemniki zavrnejo ali premaknejo med vsiljeno pošto. Za ta nabiralnik nastavite SMTP lastnega poštnega strežnika."
        },
        "mx_missing": {
          "TITLE": "Domena nima zapisa MX",
          "DESCRIPTION": "Brez zapisa MX nihče ne more pošiljati e-pošte na domeno, zato stranke ne morejo odgovoriti na vaša sporočila."
        }
      }
    },
    "NOTE": "Note: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Website Avatar",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar deleted successfully",
              "ERROR_MESSAGE": "There was an error, please try again"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Website Name",
          "PLACE_HOLDER": "Enter your website name (eg: Acme Inc)",
          "ERROR": "Please enter a valid website name"
        },
        "WELCOME_HEADING": {
          "LABEL": "Welcome Heading",
          "PLACE_HOLDER": "Hi there!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Welcome Tagline",
          "PLACE_HOLDER": "We make it simple to connect with us. Ask us anything, or share your feedback."
        },
        "REPLY_TIME": {
          "LABEL": "Reply Time",
          "IN_A_FEW_MINUTES": "In a few minutes",
          "IN_A_FEW_HOURS": "In a few hours",
          "IN_A_DAY": "In a day"
        },
        "WIDGET_COLOR_LABEL": "Widget Color",
        "WIDGET_BUBBLE_POSITION_LABEL": "Widget Bubble Position",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Največja višina neprebranih sporočil (px)",
          "PLACE_HOLDER": "Brez omejitve",
          "HELP_TEXT": "Omejite največjo višino pojavnega okna z neprebranimi sporočili v slikovnih pikah. Pustite prazno za privzeto vedenje (brez omejitve)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Widget Bubble Type",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Klepetajte z nami",
          "LABEL": "Widget Bubble Launcher Title",
          "PLACE_HOLDER": "Klepetajte z nami"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Update Widget Settings",
          "API": {
            "SUCCESS_MESSAGE": "Widget settings updated successfully",
            "ERROR_MESSAGE": "Unable to update widget settings"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Preview",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Left",
          "RIGHT": "Right"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Expanded Bubble"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Default",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Običajno odgovorimo v nekaj minutah",
        "IN_A_FEW_HOURS": "Običajno odgovorimo v nekaj urah",
        "IN_A_DAY": "Običajno odgovorimo v enem dnevu"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Začni pogovor",
        "CHAT_INPUT_PLACEHOLDER": "Vnesite svoje sporočilo"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "We are Online",
          "OFFLINE": "Trenutno nismo na voljo"
        },
        "USER_MESSAGE": "Hi",
        "AGENT_MESSAGE": "Hello"
      },
      "BRANDING_TEXT": "Poganja JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Other Providers"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Spletna stran",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "E-pošta",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API Channel",
      "PHONE": "SIP telefon",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
